import actions from './actions';
import { moduleName } from './constants';
import { lang } from './lang';
import reducer from './reducer';
import { rootSaga } from './sagas';
import { selectors } from './selectors';

export const HFTModule = {
    actions,
    lang,
    moduleName,
    reducers: {
        [moduleName]: reducer
    },
    saga: rootSaga,
    selectors,
};

export default HFTModule as IReduxModule;


// WEBPACK FOOTER //
// ./src/redux/modules/hft/entry.tsx